
export default function StoriaSection() {
  return (
    <section id="storia" className="py-16 md:py-32 bg-white relative overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-5 md:px-8 relative z-10">
        {/* Header */}
        <div className="flex items-center gap-3 mb-5">
          <div className="w-8 h-[1px] bg-[#6b8e7f]"></div>
          <span className="font-montserrat text-[10px] md:text-[11px] uppercase tracking-[3px] md:tracking-[4px] text-[#6b8e7f]">
            La Mia Storia
          </span>
        </div>
        <h2 className="font-playfair text-[32px] md:text-[52px] font-bold text-[#2d3e40] leading-[1.15] mb-10 md:mb-16">
          Tra Tradizione Classica<br className="hidden md:block" /> e Visione{' '}
          <em className="text-[#6b8e7f] not-italic">Ecologica</em>
        </h2>

        {/* Main Content */}
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
          {/* Left - Image Stack */}
          <div className="w-full lg:w-[45%] relative">
            <div className="relative">
              <div className="w-full h-[350px] sm:h-[420px] lg:h-[500px] rounded-2xl overflow-hidden shadow-[0_8px_40px_rgba(0,0,0,0.08)]">
                <img
                  src="https://public.readdy.ai/ai/img_res/5a0b46672abe24c3fdd1b96839c93f86.jpg"
                  alt="Tavolo da disegno architettonico"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Floating Quote Card */}
              <div className="absolute -bottom-6 right-2 md:-bottom-8 md:-right-8 bg-[#2d3e40] rounded-2xl p-5 md:p-8 max-w-[240px] md:max-w-[280px] shadow-[0_12px_40px_rgba(0,0,0,0.15)]">
                <div className="font-playfair text-[32px] md:text-[40px] text-[#6b8e7f] leading-none mb-2">
                  &ldquo;
                </div>
                <p className="font-playfair italic text-[14px] md:text-[16px] text-white/90 leading-[1.6]">
                  L&apos;edificio non occupa lo spazio, ma vive in simbiosi con esso.
                </p>
                <div className="w-8 h-[2px] bg-[#6b8e7f] mt-4"></div>
                <span className="font-montserrat text-[10px] md:text-[11px] text-white/50 mt-3 block uppercase tracking-[2px]">
                  Marco Incitti
                </span>
              </div>
            </div>
          </div>

          {/* Right - Text */}
          <div className="w-full lg:w-[55%] pt-4 mt-6 lg:mt-0">
            <div className="space-y-5 md:space-y-7">
              <p className="font-montserrat text-[14px] md:text-[15px] leading-[1.9] md:leading-[2] text-[#2d3e40]/80">
                Nato a Roma il{' '}
                <strong className="text-[#2d3e40] font-semibold">
                  28 settembre 1975
                </strong>
                , Marco Incitti ha ereditato il mestiere del costruire tra i tavoli da
                disegno del padre,{' '}
                <strong className="text-[#2d3e40] font-semibold">
                  Dimarco Incitti
                </strong>
                , un architetto di stampo classico che gli ha insegnato la sacralità
                della struttura.
              </p>
              <p className="font-montserrat text-[14px] md:text-[15px] leading-[1.9] md:leading-[2] text-[#2d3e40]/80">
                Tuttavia, Marco ha scelto di evolvere questa eredità classica.
                Integrando le filosofie occidentali di{' '}
                <strong className="text-[#6b8e7f] font-semibold">
                  sostenibilità
                </strong>{' '}
                e i sistemi tecnologici bio-climatici, ha trasformato la tradizione in
                una visione ecologica radicale che oggi definisce il suo approccio
                unico all&apos;architettura contemporanea.
              </p>
              <p className="font-montserrat text-[14px] md:text-[15px] leading-[1.9] md:leading-[2] text-[#2d3e40]/80">
                Ogni progetto è un ponte tra la solidità del passato paterno e la
                necessità di un pianeta protetto, dove l&apos;edificio non occupa lo
                spazio, ma vive in{' '}
                <strong className="text-[#6b8e7f] font-semibold">
                  simbiosi
                </strong>{' '}
                con esso. Questa filosofia ha portato Marco a collaborare con
                istituzioni internazionali e a ricevere riconoscimenti per
                l&apos;innovazione nella bio-architettura.
              </p>
            </div>

            {/* Timeline Milestones */}
            <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
              {[
                {
                  year: '1975',
                  text: "Nasce a Roma, figlio dell'architetto Dimarco Incitti",
                },
                {
                  year: '1998',
                  text: 'Laurea in Architettura con specializzazione in Bio-edilizia',
                },
                {
                  year: '2005',
                  text: 'Fonda lo studio di architettura ecologica a Roma',
                },
                {
                  year: '2024',
                  text: 'Oltre 150 progetti sostenibili completati in Italia',
                },
              ].map((item, i) => (
                <div key={i} className="flex gap-4 items-start">
                  <span className="font-playfair text-[24px] md:text-[28px] font-bold text-[#6b8e7f] leading-none mt-1 shrink-0">
                    {item.year}
                  </span>
                  <p className="font-montserrat text-[12px] md:text-[13px] text-[#2d3e40]/65 leading-[1.7]">
                    {item.text}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
